import React, { useContext, useEffect, useState } from "react"; // Añadir useState
import { Link } from "react-router-dom";
import { AppContext } from "../utilities/context";
import { FormattedMessage, useIntl } from "react-intl";
import Layout from "./Layout";
import Styles from "../../public/assets/css/main.css";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import SailingIcon from '@mui/icons-material/Sailing';

const ShowsList = () => {
  const context = useContext(AppContext);
  const intl = useIntl();

  // 1. Usa useState para almacenar los shows
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (context) {
      // context.updateBreadcrumbsState([]);
    }

    // 2. Función asíncrona para cargar los datos
    const fetchShows = async () => {
      try {
        const nocache = new Date().getTime();
        const response = await fetch(`/shows.json?nocache=${nocache}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setShows(data); // Actualiza el estado con los datos cargados
      } catch (e) {
        console.error("Error fetching shows:", e);
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    fetchShows(); // Llama a la función para cargar los shows
  }, []); // El array de dependencia vacío asegura que esto se ejecute solo una vez al montar

  if (loading) {
    return (
      <Layout>
        <p><FormattedMessage id="loading" defaultMessage="Cargando shows..." /></p>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <p><FormattedMessage id="errorLoading" defaultMessage="Error al cargar los shows." /></p>
      </Layout>
    );
  }

  return (
    <Layout>
      <List sx={{ width: "100%", bgcolor: "#f1f1f1" }}>
        {shows.map((show) => (
          <ListItem key={show.id}>
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: "#1976d2" }}>
                <SailingIcon />
              </Avatar>
            </ListItemAvatar>
            <Link className="show-link" to={`/shows/${show.id}`}>{show.title}</Link>
          </ListItem>
        ))}
      </List>
    </Layout>
  );
};

export default ShowsList;